import React from "react";
import { FiShield, FiZap, FiGlobe, FiTrendingUp, FiSmartphone, FiCpu, FiLayers } from "react-icons/fi";
import { LuShield, LuSettings, LuPalette, LuSearch, LuCircleCheck, LuUsers, LuSmartphone, LuShieldCheck, LuPercent, LuRocket, LuCode, LuClipboardList } from "react-icons/lu";

export const hybridAppServices = [
  {
    icon: <img src="/images/icons/flutter.webp" alt="Flutter" className="w-9 h-10" />,
    title: "Flutter App Development",
    description: "Build fast and scalable cross-platform applications using a single codebase for smooth iOS and Android experience.",
    image: "/images/MobileAppDevelopment/Flutter_App_Solutions.png",
    link: "/flutter-app-development-services-india",
  },
  {
    icon: <img src="/images/icons/ionic.webp" alt="Ionic" className="w-9 h-9" />,
    title: "Ionic App Development",
    description: "Create hybrid apps using web technologies like HTML, CSS, and JavaScript for flexible cross-platform deployment.",
    image: "/images/MobileAppDevelopment/cross_platform_development.png",
    link: "/ionic-app-development-services-india",
  },
  {
    icon: <img src="/images/icons/reactnative.webp" alt="React Native" className="w-9 h-9" />,
    title: "React Native Development",
    description: "Develop near-native mobile applications using React for high performance and reusable components.",
    image: "/images/MobileAppDevelopment/React_Native_Apps.png",
    link: "/react-native-app-development-services-india",
  },
  {
    icon: <img src="/images/icons/pwaicon.webp" alt="PWA" className="w-9 h-9" />,
    title: "PWA Development",
    description: "Build progressive web apps that deliver app-like experience directly in the browser without installation.",
    image: "/images/MobileAppDevelopment/PWA_Development.png",
    link: "/pwa-development-services-india",
  },
];

export const HybridHeroData = {
  backgroundImage: "/images/serviceBanners/HybridApp.webp",
  whiteImage: "/images/serviceBanners/HybridBannerW.webp",
  subTitle: "Hybrid App Development Services",
  title: (
    <>
      Build High-Performance <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Hybrid Applications</span>
    </>
  ),
  description:
    "We develop high performance hybrid applications using a single codebase to deliver smooth, consistent, and scalable experiences across iOS and Android platforms with faster development and efficient performance.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Hybrid Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("Hybrid Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance",
      desc: "Fast and optimized hybrid app performance.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Design",
      desc: "Smooth experience across all devices and screen sizes.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure & Reliable",
      desc: "Built with strong security and scalable architecture.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Clean Code",
      desc: "Maintainable and developer-friendly code structure.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/icons/rwacticon.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

// 2. Stats Block
export const hybridStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const hybridSolutionsAndProcessData = {
  buildSubtitle: "OUR CAPABILITIES",
  buildTitle: "Hybrid App Development Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform App Development",
      desc: "Build high-performance apps for Android and iOS using scalable hybrid technologies.",
      icon: FiZap,
      colorClass: "text-[#61dafb]",
      bgClass: "bg-[#61dafb]/10",
      borderClass: "border-[#61dafb]/20 hover:border-[#61dafb]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(97,218,251,0.25)]",
    },
    {
      title: "Enterprise Mobile Solutions",
      desc: "Develop secure and scalable apps for large business operations and workflows.",
      icon: FiSmartphone,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce App Development",
      desc: "Create feature-rich shopping apps with smooth checkout and secure payments.",
      icon: FiLayers,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand App Solutions",
      desc: "Build real-time booking and service apps with fast performance and updates.",
      icon: FiGlobe,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech App Development",
      desc: "Develop secure financial applications with modern user experience and compliance.",
      icon: FiSmartphone,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom Mobile App Solutions",
      desc: "Build tailored hybrid apps based on specific business requirements and logic goals.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "HYBRID APP DEVELOPMENT PROCESS",
  processTitle: "Hybrid App Development Process",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Consultation",
      description: "Understand business goals, target audience, and hybrid app requirements.",
      icon: LuSearch,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define features, tech stack, and cross-platform development roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create modern and user-friendly interfaces for hybrid applications.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Mobile App Development",
      description: "Build scalable hybrid apps with clean and maintainable architecture.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Quality Testing",
      description: "Test performance, security, and cross-device compatibility layouts.",
      icon: LuCircleCheck, // Replaced with compile-safe variant to secure modern bundler execution
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch hybrid apps and provide ongoing updates and maintenance routines.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR HYBRID APP DEVELOPMENT SERVICES?",
  benefitsTitle: "Why Businesses Choose Hybrid App Development Solutions",
  benefits: [
    "Cross-platform support",
    "Faster development cycle",
    "Modern UI design",
    "Smooth performance output",
    "Efficient workflow system",
    "Scalable mobile solutions",
    "Cost-effective development",
  ],
  logoImage: "/images/serviceBanners/HybridApp.webp",
  whiteLogoImage: "/images/serviceBanners/HybridBannerW.webp",
};
// 4. Portfolio Data
export const hybridPortfolioData = {
  subtitle: "SUCCESS STORIES",
  title: "Hybrid Apps Powering Growth",
  buttonText: "View Case Studies",
  buttonLink: "#",
  apps: [
    {
      title: "Global Commerce Hub",
      badge: "Retail PWA",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A multi-platform retail app handling 500k+ users with 95% shared code.",
      downloads: "Active",
      rating: "5.0",
      image: "/images/MobileAppDevelopment/React_Native_Apps.png",
    },
  ],
};

// 5. Technologies Data
export const hybridTechnologiesData = {
  techTitle: "HYBRID TOOL STACK",
  technologies: [
    { name: "React Native", icon: "ReactJS" },
    { name: "Flutter", icon: "RestAPI" }, // Mock mapping
    { name: "Ionic", icon: "Vite" },
    { name: "Firebase", icon: "Firebase" },
    { name: "Node.js", icon: "ReactNative" },
    { name: "TypeScript", icon: "Dart" },
  ],
  trustTitle: "TRUSTED BY TECHNOLOGY LEADERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview
export const hybridAboutData = [
  {
    title: "Hybrid App Development Company for Scalable Mobile Experiences",
    content: (
      <>
        Modern businesses need mobile applications that perform consistently across devices without increasing development complexity. A trusted{" "}
        <b className="text-text-primary font-semibold">hybrid app development company</b> helps organizations create scalable mobile experiences that improve accessibility,
        customer engagement, and operational flexibility. Many businesses struggle with maintaining separate applications for multiple platforms, which increases cost and slows
        product updates. At <b className="text-text-primary font-semibold">Tycho Technologies</b>, hybrid applications are developed around business objectives, usability, and
        long-term scalability to help companies create efficient mobile ecosystems that support sustainable growth.
      </>
    ),
  },
  {
    title: "Cross Platform App Development for Better Business Efficiency",
    content: (
      <>
        Building applications that work smoothly across multiple devices has become essential for modern digital success. Reliable{" "}
        <b className="text-text-primary font-semibold">cross platform app development</b> helps businesses improve reach while maintaining a consistent user experience across
        operating systems. Companies investing in <b className="text-text-primary font-semibold">hybrid mobile app development services</b> often improve efficiency because
        applications can adapt more easily to changing business requirements and customer expectations. Tycho Technologies focuses on practical cross-platform strategies designed
        to improve performance while supporting long-term digital transformation.
      </>
    ),
  },
  {
    title: "Flutter App Development Company for Smarter Mobile Solutions",
    content: (
      <>
        Businesses aiming to improve mobile performance often prioritize technologies that simplify development and improve usability. A trusted{" "}
        <b className="text-text-primary font-semibold">flutter app development company</b> helps organizations create responsive applications that support better customer
        interaction and faster product scalability. Companies strengthening mobile ecosystems frequently align digital strategies with{" "}
        <a href="https://tychotechnologies.com/ipad-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ipad app development company
        </a>{" "}
        solutions to improve user accessibility and create connected experiences across devices.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Hybrid App Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">hybrid app development company in india</b> continues to grow as businesses seek scalable and
        flexible mobile technologies. Companies investing in <b className="text-text-primary font-semibold">cross platform app development india</b> often prioritize performance,
        cost efficiency, and better customer experiences. Businesses partnering with Tycho Technologies gain access to customized hybrid frameworks designed around measurable
        business goals and user expectations. Many organizations also strengthen mobile ecosystems through{" "}
        <a href="https://tychotechnologies.com/ios-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ios app development company
        </a>{" "}
        solutions to support premium digital experiences across Apple devices.
      </>
    ),
  },
];
// 7. FAQs (Preserved)
export const hybridAppFaqs = [
  {
    q: "Will my hybrid app feel native?",
    a: "Modern frameworks like React Native and Flutter interact directly with OS APIs, making the application visually and functionally indistinguishable from native builds.",
  },
  {
    q: "Do I have access to native device features?",
    a: "Yes. Hybrid architectures utilize bridges to access native components like cameras, GPS, and push notifications.",
  },
];
